// React
import React, { Component } from 'react';
import {ButtonGroup, IconButton} from '@material-ui/core/';
import {functions} from 'constants/index';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import Footer from 'pages/Home/Footer2';
import LoadingSpinner from 'components/LoadingSpinner';
import CustomToolTip from 'components/tooltip/';
import {showMessagePersonalizedPosition, showMessageError} from 'services/SweetAlert'
import DataComparisonDialog from './DataComparisonDialog'
import { Description, FindInPage, RestorePage, Person, DeleteForever, CloudUpload } from '@material-ui/icons';
import ModalObservation from 'components/ModalObservation';
import ComponenteBusquedaPorNumeroDeFolio from '../QueTienenUnaCoincidenciaExacta/ConsultaPorFolio'
import MostrarPDFModal from 'components/PdfModal'
import DialogLoadingMessage from 'components/LoadingMessage/index'
import ComponenteParaEliminarRegistroDeFallecido from '../QueTienenUnaCoincidenciaExacta/ComponenteEliminarRegistro'
import ComponenteParaVisualizarOCargarDocumentoPDFFallecidos from '../QueTieneUnaCoincidenciaNoExacta/VisualizaroCargarDocumentoPDF';

class ModuloFallecidos extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            controller:'captacionFallecidos',
            loading: false,
            authorized:true,
            checkAutorization:true,
            data: [],
            header: [
                { title: 'Registro No.', field: 'iddetalle',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre Fallecido', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Nombre Padre', field: 'nombrePadreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'Nombre Madre', field: 'nombreMadreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'CUI', field: 'cui' },
                { title: 'Cédula', field: 'cedula' },
                { title: 'Departamento Extensión', field: 'departamentoextensionn.nameShort' },
                { title: 'Municipio Extensión', field: 'municipioextensionn.municipio' },
                { title: 'Número boleta', field: 'nroboleta' },
                { title: 'Departamento Nacimiento', field: 'departamentonacimineto.nameShort' },
                { title: 'Municipio Nacimiento', field: 'municipionacimienton.municipio' },
                { title: 'Fecha Nacimiento', field: 'fechaNacimientoformato' },
                { title: 'Departamento defunción', field: 'datosfolio.departamentov.nameShort' },
                { title: 'Municipio defunción', field: 'datosfolio.municipiov.municipio',
                    render: rowData=><div>
                        {
                            (rowData.datosfolio?.auxiliatura === null) ?
                            (rowData.datosfolio?.municipiov?.municipio) :
                            (rowData.datosfolio?.auxiliatura?.municipio?.municipio)
                        }
                    </div>
                },
                { title: 'Auxiliatura', field: 'datosfolio.auxiliatura.name', },
                { title: 'Fecha Defunción', field: 'fechaDefuncionformato' },
                { title: 'Fecha Defunción Asentamiento', field: 'fechaasientoString' },
                // { title: 'Usuario', field: 'usuarioDigita', },
                // { title: 'Fecha de creación', field: 'fechaCreacionString', },
                // { title: 'Hora de creación', field: 'horaCreacionString', },
                { title: 'Origen', field: 'datosfolio.datosorigen', },
                { title: 'Folio No.', field: 'datosfolio.idfolio',cellStyle:{ maxWidth: '80px' } },                
                { title: 'Datos folio', field: '', 
                    render: (rowData) => (
                        <div>
                            {(rowData.datosfolio) ? (
                                <IconButton  size="small" color="primary"
                                    onClick={() => {
                                        let observacion = []
                                        observacion.push({title:'Origen: ', text: rowData?.datosfolio?.datosorigen})                                        
                                        observacion.push({title:'Folio: ', text: rowData?.datosfolio?.idfolio})
                                        observacion.push({title:'Departamento: ', text: rowData?.datosfolio?.departamentov?.nameShort})
                                        observacion.push({title:'Municipio: ', text: (
                                            (rowData?.datosfolio?.auxiliatura === null) ?
                                            (rowData?.datosfolio?.municipiov?.municipio) :
                                            (rowData?.datosfolio?.auxiliatura?.municipio?.municipio)                                            
                                        )})
                                        observacion.push({title: 'Auxiliatura: ', text: (rowData.datosfolio?.auxiliatura?.name) ? (rowData.datosfolio?.auxiliatura?.name):('')})
                                        observacion.push({title: 'Año: ', text: rowData?.datosfolio?.año})
                                        observacion.push({title: 'Fecha Inicio: ', text: functions.dateFormatGeneral(rowData?.datosfolio?.fechainicio)})
                                        observacion.push({title: 'Fecha Final: ', text: functions.dateFormatGeneral(rowData?.datosfolio?.fechafinal)})
                                        this.abrirObservacion();
                                        this.setState({ textoObservacion: observacion, title:'Datos del Folio' })
                                    }}
                                >
                                    <img alt="comments" style={{ height: 40, width: 40 }} src="/assets/comments.svg" />
                                </IconButton>
                            ) : ""}
                        </div>
                )},                                
                { title: 'Acción', field: 'accion',
                    render: rowData=><div>
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            <CustomToolTip title="Visualizar o cargar documento" handleFunction={() => this.AbrirvisualizaroCargarDocumentoPDF(rowData)}><CloudUpload/></CustomToolTip>                            
                            <CustomToolTip title="Ver Información" handleFunction={() => this.mostrarDialogoParaPasarAFallecido(rowData)}><Person/></CustomToolTip>
                            {                            
                                (rowData.datosfolio.origen === 1) ?
                                    <CustomToolTip title="Eliminar Registro" handleFunction={() => this.abrirComponenteEliminarEditarRegistro(rowData)}><DeleteForever style={{color: '#C0392B'}}/></CustomToolTip>                                
                                : (rowData.datosfolio.origen === 2) ?
                                    <CustomToolTip title="REPORTE DE FALLECIDOS - RENAP" handleFunction={() => this.mostrarReporteDeFallecidosDeRenap(rowData)}><Description style={{color: '#1E88E5'}}/></CustomToolTip>
                                :''
                            }
                        </ButtonGroup>                        
                    </div>            
                }, 
            ],
            currentUser: props.currentUser,
            abrirModalTSEVirtual: false,
            // formulario captación de fallecidos
            openFormCaptacionFallecidos: false,
            // abrir el formulario para pasar a fallecido a ciudadanos
            openFormPasarAFallecido:false,
            datosDelCiudadanoAComparar:{}, tableData:{},
            textoObservacion: '', title: '', openObservacion:false,
            //variables para el componente de busqueda por folio
            openModalSearchByFolio: false,
            // lista de botones para el componente table
            buttonList: [],
            // variables para mostrar reporte de fallecidos de origen renap
            openModalReporteFallecidosRenap: false, base64ReporteFallecidosRenap: '', loadingMessage: {open: false, title: ''},
            //eliminar registro cuando se crea desde el formulario
            openFormDeleteRegister:false, loadingFormDeleteRegister: false, datosDelRegistroDelFallecido:{},
            saveDatatoFormDeleteAndEdit:{}, origenRegistro:'',
            //visualizar o Cargar DocumentoPDF
            openModalVisualizarCargarDocumentoPDF:false, datosParaVisualizarOCargarDocumentosPDF:''            
        }
    //declaraciones de todas las funciones que se utilizaran
        this.showList = this.showList.bind(this);
        this.mostrarComponenteCaptaciónDeFallecidos = this.mostrarComponenteCaptaciónDeFallecidos.bind(this);
        this.cerrarComponenteCaptaciónDeFallecidos = this.cerrarComponenteCaptaciónDeFallecidos.bind(this);
        this.mostrarDialogoParaPasarAFallecido = this.mostrarDialogoParaPasarAFallecido.bind(this);
        this.cerrarDialogoParaPasarAFallecido = this.cerrarDialogoParaPasarAFallecido.bind(this);                
        this.abrirObservacion = this.abrirObservacion.bind(this);
        this.cerrarObservacion = this.cerrarObservacion.bind(this);
        this.openComponentSearchByFolio = this.openComponentSearchByFolio.bind(this);
        this.closeComponentSearchByFolio = this.closeComponentSearchByFolio.bind(this);        
        this.ArrayDeMenuDeBotonesDesplegables = this.ArrayDeMenuDeBotonesDesplegables.bind(this);
        // MOSTRAR DOCUMENTO DE REPORTE DE FALLECIDOS DE ORIGEN RENAP
        this.mostrarReporteDeFallecidosDeRenap = this.mostrarReporteDeFallecidosDeRenap.bind(this);
        this.cerrarReporteDeFallecidosDeRenap = this.cerrarReporteDeFallecidosDeRenap.bind(this);
        // eliminar registro unicamente cuando se crea desde el formulario
        this.abrirComponenteEliminarEditarRegistro = this.abrirComponenteEliminarEditarRegistro.bind(this);
        this.cerrarComponenteEliminarEditarRegistro = this.cerrarComponenteEliminarEditarRegistro.bind(this);      
        this.AbrirvisualizaroCargarDocumentoPDF = this.AbrirvisualizaroCargarDocumentoPDF.bind(this);
        this.CerrarVisualizaroCargarDocumentoPDF = this.CerrarVisualizaroCargarDocumentoPDF.bind(this);          
    }
        abrirObservacion(){
            this.setState({ openObservacion: true })
        }
        cerrarObservacion(){
            this.setState({ openObservacion: false })
        }                
    // captación de fallecidos
        mostrarComponenteCaptaciónDeFallecidos(){
            this.setState({openFormCaptacionFallecidos: true})
        }
        cerrarComponenteCaptaciónDeFallecidos(){
            this.setState({openFormCaptacionFallecidos: false})
        }
    // Pasar a fallecido a ciudadano
        async mostrarDialogoParaPasarAFallecido(data){
            this.setState({loadingMessage: {open:true, title: 'Obteniendo datos. Espere un momento ....'}})
            try {
                let response = await ApiServices.captacionFallecidos.obtenerFallecido({id: [data.iddetalle.toString()]})
                if(response.error!==null){
                    showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                }
                else{
                    this.setState({datosDelCiudadanoAComparar: response.data, tableData: data, openFormPasarAFallecido: true})
                }
            } catch (error) {
                if(error.status===404) {
                    showMessagePersonalizedPosition('error','Oopss!', 'Falla del Sistema. póngase en contacto con el Administrador sí este mensaje persiste.','center')
                }else {
                    showMessagePersonalizedPosition('error','Oopss!', 'Intente de nuevo. póngase en contacto con el Administrador sí este mensaje persiste.','center')
                }                
            }
            this.setState({loadingMessage: {open:false, title: ''}})
        }
        cerrarDialogoParaPasarAFallecido(){
            this.setState({openFormPasarAFallecido: false})
        }                
    // cargamos todas las solicitudes de renap en la tabla
        async showList(){
            try{
                this.setState({loading: true, checkAutorization: true});
                const hasPermission = await ApiServices.userSecurity.hasPermission(this.state.controller,'list');    
                if (hasPermission.error){
                    this.setState({checkAutorization: false,authorized: false,loading: false });
                }else{
                    ApiServices[this.state.controller].initSearchCriteria.clear();
                    ApiServices[this.state.controller].initOrderCriteria.clear();
                    ApiServices[this.state.controller].initSearchCriteria.setOperator("and");
                    ApiServices[this.state.controller].initSearchCriteria.addEquals("estadoDiferencia", 2);
                    ApiServices[this.state.controller].initOrderCriteria.addAsc("iddetalle");
                    this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
                }
            }catch(exception){
                if(exception.status===404) {
                    showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }else {
                    showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
                }
                this.setState({ loading: false,checkAutorization: false, data:[]});
            }
        }
        async componentDidMount() {  
            this.showList();
            this.ArrayDeMenuDeBotonesDesplegables()
        }
        componentDidUpdate() {
            // this.showList(); 
        }    
    // funciones para el componente busqueda por numero de folio
        openComponentSearchByFolio(data){              
            this.setState({openModalSearchByFolio: true})
        }
        closeComponentSearchByFolio(){
            this.setState({openModalSearchByFolio: false})
        }        
        ArrayDeMenuDeBotonesDesplegables(){
            this.setState({buttonList:[
                {
                    customTitleButtonTable:"Búsqueda por folio",
                    customIconButtonTable:<FindInPage/>,
                    customFunctionTable:this.openComponentSearchByFolio,
                },
                {
                    customTitleButtonTable:"Actualizar Tabla",
                    customIconButtonTable:<RestorePage/>,
                    customFunctionTable:this.showList,
                }                
            ]})            
        }
    // funciones parar mostrar reporte de fallecidos de origen renaplogo
        async mostrarReporteDeFallecidosDeRenap(data){
            this.setState({loadingMessage: {open:true, title: 'Cargando reporte de fallecidos - RENAP'}})
            try {
                let response = await ApiServices.captacionFallecidos.visalizarpdf(data.iddetalle)
                if(response.error!==null){
                    showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                }
                else{
                    this.setState({base64ReporteFallecidosRenap: response.data, openModalReporteFallecidosRenap: true})
                }
            } catch (error) {
                if(error.status===404) {
                    showMessagePersonalizedPosition('error','Oopss!', 'Falla del Sistema. póngase en contacto con el Administrador sí este mensaje persiste.','center')
                }else {
                    showMessagePersonalizedPosition('error','Oopss!', 'Intente de nuevo. póngase en contacto con el Administrador sí este mensaje persiste.','center')
                }                
            }        
            this.setState({loadingMessage: {open:false, title: ''}})
        }
        cerrarReporteDeFallecidosDeRenap(){
            this.setState({openModalReporteFallecidosRenap: false})
        }
    // funciones para el componente eliminar registro cuando se crea desde el formulario
        abrirComponenteEliminarEditarRegistro(data){                
            let saveData = {
                nrofolio: data.datosfolio.idfolio,
                año: data.datosfolio.año,
                fechainicio: data.datosfolio.fechainicio,
                fechafinal: data.datosfolio.fechafinal,
                coddepto: {id: data.datosfolio.departamentov.id, name: data.datosfolio.departamentov.nameShort},
                codmunic: {
                    id: ((data.datosfolio.auxiliatura) ? (data.datosfolio.auxiliatura.municipio.id) : (data.datosfolio.municipiov.id)), 
                    name:((data.datosfolio.auxiliatura) ? (data.datosfolio.auxiliatura.municipio.municipio) : (data.datosfolio.municipiov.municipio)),  
                },
                codauxiliatura: {id: data.datosfolio?.auxiliatura?.id, name: data.datosfolio?.auxiliatura?.name},
                nroboleta: data.nroboleta,
                cui: data.cui,
                nroorden: data.nroorden,
                nroregistro: data.nroregist,
                estado: data.estatusPadron,
                fechanacimiento: data.fechanacimiento,
                fechadefuncion: data.fechadefuncion,
                apellido1fallecido: data.apellido1fallecido,
                apellido2fallecido: data.apellido2fallecido,
                apellido3fallecido: data.apellido3fallecido,
                nombre1fallecido: data.nombre1fallecido,
                nombre2fallecido: data.nombre2fallecido,
                apellido1padre: data.apellido1padre,
                apellido2padre: data.apellido2padre,
                nombrepadre: data.nombrepadre,
                apellido1madre: data.apellido1madre,
                apellido2madre: data.apellido2madre,
                nombremadre: data.nombremadre
            }
            this.setState({origenRegistro: data.datosfolio.origen , saveDatatoFormDeleteAndEdit: saveData, idDetalleDelFallecido: data.iddetalle, datosDelRegistroDelFallecido: data, openFormDeleteRegister: true})
        }
        cerrarComponenteEliminarEditarRegistro(){
            this.setState({openFormDeleteRegister: false})
        }   
    //visualizar o Cargar DocumentoPDF
        AbrirvisualizaroCargarDocumentoPDF(data){
            this.setState({openModalVisualizarCargarDocumentoPDF: true, datosParaVisualizarOCargarDocumentosPDF: data})
        }
        CerrarVisualizaroCargarDocumentoPDF(){
            this.setState({openModalVisualizarCargarDocumentoPDF: false,})
        }        

    render() {
        if (this.state.checkAutorization ) return <DialogLoadingMessage open={this.state.loading} title={'Cargando listado que no tienen coincidencias dentro del padrón ...'}/> 
        return (
            <div>
                <DialogLoadingMessage open={this.state.loadingMessage.open} title={this.state.loadingMessage.title}/>
                <ModalObservation open={this.state.openObservacion}  handleClose={this.cerrarObservacion} textoObservacion={this.state.textoObservacion} title={this.state.title} />
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}
                <DataComparisonDialog 
                    open={this.state.openFormPasarAFallecido}
                    closeModal={this.cerrarDialogoParaPasarAFallecido}
                    actualizarTabla={this.showList}
                    datosDelCiudadanoAComparar={this.state.datosDelCiudadanoAComparar}
                    tableData={this.state.tableData}
                />                
                {window.screen.width >= 1024 ? (
                    <Table  
                            service={ApiServices[this.state.controller]}
                            title={"Listado que no tienen coincidencias dentro del padrón"}
                            // addRegister={this.mostrarComponenteCaptaciónDeFallecidos} 
                            // nameToolTipAdd={"Captación de fallecidos"}
                            header = {this.state.header}
                            showFilterGeneral={false}
                            refreshList={this.showList}
                            isMenuDesplegable={true}
                            arrayMenuDesplegable={this.state.buttonList}
                    />
                ) : ("") }
                <ComponenteBusquedaPorNumeroDeFolio 
                    open={this.state.openModalSearchByFolio}
                    closeModal={this.closeComponentSearchByFolio}
                    actualizarTabla={this.showList}
                />
                {/* componente para mostrar el reporte de fallecidos de origen renap */}
                    <MostrarPDFModal 
                        open={this.state.openModalReporteFallecidosRenap} 
                        handleClose={this.cerrarReporteDeFallecidosDeRenap} 
                        title={'Reporte de fallecidos - RENAP'}
                        base64={this.state.base64ReporteFallecidosRenap}
                    />
                {
                    this.state.openFormDeleteRegister ? 
                    <ComponenteParaEliminarRegistroDeFallecido 
                        open={this.state.openFormDeleteRegister}
                        actualizarTabla={this.showList}
                        cerrarComponenteEliminarRegistro={this.cerrarComponenteEliminarEditarRegistro}
                        idRegistro={this.state.idDetalleDelFallecido}
                        datosDelFallecido={this.state.datosDelRegistroDelFallecido}
                        saveDatatoFormDeleteAndEdit={this.state.saveDatatoFormDeleteAndEdit}
                    />:''
                }
                {
                    this.state.openModalVisualizarCargarDocumentoPDF && (                        
                        <ComponenteParaVisualizarOCargarDocumentoPDFFallecidos 
                            titleToolbar={'Visualizar o cargar documento PDF'}
                            open={this.state.openModalVisualizarCargarDocumentoPDF}
                            data={this.state.datosParaVisualizarOCargarDocumentosPDF}
                            closeModal={this.CerrarVisualizaroCargarDocumentoPDF}
                            actualizarTabla={this.showList}
                            fullScreen={true}
                        />
                    )
                }                
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuloFallecidos);